<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <button :class="b()">
    <span :class="b('icon')" v-html="displayedIcon"></span>
  </button>
</template>
